<script>
/**
 * Type        : Business component
 * Title       : 콘솔 목록
 * Description : 콘솔 목록을 보여주는 컴포넌트
 * 
 */
import RegiConsolForm from "@/components/admin/logis/modal/RegiConsolForm.vue"

export default {
  name: "Console-list",
  components:{
    RegiConsolForm
  },
  props: {
    type : String,
    consolList : Array, // 부모 컴포넌트에서 전달받는 콘솔 목록
    loading: Boolean,
  },
  emits: [
    'load-consol-list', // 콘솔 목록 새로고침 이벤트
  ],
  computed: {
    partnerList () {
      if (!Array.isArray(this.orderList)) {
        return []
      }

      const map = new Map()
      
      map.set('전체',{
        id: null,
        name: '전체파트너'
      })

      this.orderList.forEach(order => {
        if (!order) {
          return
        }

        const name = order.partnerName || ''
        const id = order.partnerId ?? order.partner_id ?? order.partnerCode ?? order.partner_code ?? null
        const key = id ?? name

        if (!key) {
          return
        }

        if (!map.has(key)) {
          map.set(key, {
            id,
            name
          })
          return
        }

        const existing = map.get(key)
        if (!existing.name && name) {
          existing.name = name
        }
        if (existing.id == null && id != null) {
          existing.id = id
        }
      })

      return Array.from(map.values())
    }
  },
  data() {
    return {
      modalConsol : false,
      mode : 0,

      // 선택된 콘솔 정보
      selectedConsol : {},

      // 콘솔에 선적된 Order 목록
      orderList: [],
      selectedList: [],
      detailLoading: false,
      expandedMap: {},
      
      columns : [
        { name: 'id', label: 'ID', align: 'center', field: 'id' },
        { name: 'statusLabel', label: '콘솔상태', align: 'center', field: 'statusLabel' },
        { name: 'mblNo', label: 'M B/L No.', align: 'center', field: 'mblNo' },
        { name: 'freightCode', label: '편명(선명)', align: 'center', field: 'freightCode' },
        { name: 'departCity', label: '출발지', align: 'center', field: 'departCity' },
        { name: 'arrivalCity', label: '도착지', align: 'center', field: 'arrivalCity' },
        { name: 'etd', label: '출발일자', align: 'center', field: 'etd' },
        { name: 'eta', label: '도착일자', align: 'center', field: 'eta' },
        { name: 'totalOrderQty', label: 'Order 수', align: 'center', field: 'totalOrderQty' },
        { name: 'totalQty', label: 'H.수량', align: 'center', field: 'totalQty' },
        { name: 'totalWeight', label: 'H.중량', align: 'center', field: 'totalWeight' },
        { name: 'totalVolumeWeight', label: '부피중량', align: 'center', field: 'totalVolumeWeight' },
        { name: 'memo', label: '콘솔 비고 메모', align: 'center', field: 'memo' },
        { name: 'updated_at', label: '최종수정일', align: 'center', field: 'updated_at' },
        { name: 'created_at', label: '등록일', align: 'center', field: 'created_at' },
        { name: 'actions', label: '기능선택', align: 'center', field: 'actions' },
      ],
      orderColumns : [
        { name: 'orderId', label: 'Order ID', align: 'center', field: 'orderId' },
        { name: 'partnerName', label: '파트너명', align: 'center', field: 'partnerName' },
        // { name: 'mblNo', label: 'M B/L No.', align: 'center', field: 'mblNo' },
        { name: 'hblNo', label: 'H B/L No.', align: 'center', field: 'hblNo' },
        { name: 'shipperName', label: '송하인명', align: 'center', field: 'shipperName' },
        { name: 'receiverName', label: '보내는 사람명', align: 'center', field: 'receiverName' },
      ],


      // 기존 csv export 컴포넌트 사용
      csvName: 'consoled-list-' + new Date().toLocaleDateString() + '.csv',
      csvHeaders:{ // Export CSV - 헤더 컬럼 필드 한글 매핑
        id                : 'ID',
        freightMethod     : '운송수단',
        regName           : '등록업체',
        customerNum       : '회원번호',
        customerName      : '회원명',
        bulkShipping      : '묶음배송여부',
        bulkSeq           : '묶음배송번호',
        bulkCnt           : '묶음배송갯수',
        courierCode       : '택배사코드',
        courierName       : '택배사',
        courierNum        : '송장번호',
        parcelStatus      : '화물상태',
        parcelLocation    : '화물위치코드',
        parcelLocationName: '화물위치명',
        parcelCode        : '화물코드',
        destiCity         : '도착지(도시)',
        pickUpLocation    : '픽업위치코드',
        pickUpLocationName: '픽업위치명',
        deliveryAddress   : '도착지주소',
        email             : '수취인 이메일',
        eatable           : '음식물여부',
        length            : '길이(cm)',
        height            : '높이(cm)',
        width             : '넓이(cm)',
        memo              : '메모',
        isDel             : '삭제여부',
        actualWeight      : '실무게(kg)',
        weight            : '부피무게(kg/CBM)',
        receiver          : '수취인',
        mobileCountry     : '수취인 국가코드',
        mobileNum         : '수취인 전화번호',
        pickupLocation    : '픽업지',
        parcelLocatonName : '위치',
        regDateOriginal   : '등록일전체',
        regDate           : '등록일',
      },

      initialPagination : {
        sortBy: 'id',
        descending: false,
        page: 1,
        rowsPerPage: 500
        // rowsNumber: xx if getting data from a server
      },
    }
  },
  methods:{
    // TODO : 고객정보 등록으로 변경 필요
    getStatusColor(status) {
      if (String(status) === '001') return 'orange'
      if (String(status) === '002') return 'blue'
      if (String(status) === '003') return 'positive'
      if (String(status) === '004') return 'negative'
      return 'grey-7'
    },
    
    /**
     * Title        : 모달 닫기
     * Status       : Actived
     * Description  : 
     */
    closeModal(){
      this.modalConsol = false
    },


    /**
     * Title        : Row click
     * Status       : Actived
     * Description  : 선택된 콘솔에 consolize 된 목록 호출
     */
    async onLoadConslizedList (evt, row) {
      this.$log.info("[ 선택된 콘솔에 consolize 된 목록 호출  ] row = ", row)

      this.selectedConsol = row
      this.selectedList = []
      this.detailLoading = true

      let result = []
      let payload = {
        consoleId : row.id
      }

      let config = {
        method  : "POST",
        url     : "/api/consol/getOrderListByConsole",
        data    : payload,
        name    : "[ Axios / consolize 된 목록 호출 ]"
      }

      try {
        const res = await this.$http(config)
        result = res.data
        this.orderList = Array.isArray(result) ? result : []
      } catch (error) {
        this.$log.debug("/parcel/getOrderListByConsole 실패", error)
        this.orderList = []
        this.$q.notify({ type: 'negative', message: '콘솔 오더 조회에 실패했습니다.', position: 'top' })
      } finally {
        this.detailLoading = false
      }
    },

    async refreshSelectedConsol() {
      this.$emit('load-consol-list')
      if (this.selectedConsol?.id) {
        await this.onLoadConslizedList(null, this.selectedConsol)
      }
    },


    /**
     * Title        : 콘솔상태 변경 전 기존 상태값 저장
     * Status       : Actived
     * Description  : 콘솔상태 변경 전 기존 상태값을 임시로 저장
     */
    savePrevStatus(consol) {
      // 이전 상태를 임시로 보관
      if (consol) {
        consol._prevStatus = consol.status
      }
    },

    /**
     * Title        : 콘솔상태 변경 전 확인
     * Status       : Actived
     * Description  : Quasar confirm 다이얼로그로 변경 여부 확인 후 updateConsolStatus 호출.
     *                취소 시 선택된 콘솔 / 콘솔 목록의 상태를 이전 값으로 롤백함.
     */
    async confirmUpdateConsolStatus(id, status, prevStatus = null) {
      this.$log.debug("[ 콘솔 상태 변경 확인 ] id =", id, ", status =", status, ", prevStatus =", prevStatus)
      // 이전 상태를 찾음 (명시적으로 전달되지 않았을 때)
      if (prevStatus === null) {
        const found = this.consolList.find(c => c.id === id)
        prevStatus = found ? found.status : null
      }

      // 상태 레이블 매핑 (store의 옵션에서 찾음)
      const options = this.$store.getters.getConsolStatusList || []
      const opt = options.find(o => {
        const val = o.value ?? o.val ?? o
        return val === status
      })
      const statusLabel = opt ? (opt.label ?? opt.name ?? String(status)) : String(status)

      await this.$q.dialog({
        title: '콘솔 상태 변경 확인',
        message: `콘솔 상태를 "${statusLabel}"(으)로 변경하시겠습니까?`,
        cancel: true,
        persistent: true
      }).onOk(async () => {
        await this.updateConsolStatus(id, status, prevStatus)
      }).onCancel(() => {
        // 취소하면 UI 상태를 이전 값으로 복원
        const found = this.consolList.find(c => c.id === id)
        if (found) {
          found.status = prevStatus
        }
        if (this.selectedConsol && this.selectedConsol.id === id) {
          this.selectedConsol.status = prevStatus
        }
        this.$q.notify({
          type: 'info',
          message: '콘솔 상태 변경이 취소되었습니다',
          position: 'top',
          timeout: 2000
        })
      })
    },

    /**
     * Title        : 콘솔 상태 업데이트
     * Status       : Actived
     * Description  : backend API 호출로 콘솔 수정.
     */
    async updateConsolStatus(id, status, prevStatus) {
      this.$log.debug("[ 콘솔 상태 업데이트 ] id =", id, ", status =", status)
      try {
        let payload = {
          consoleId   : id, // 콘솔 ID
          status      : status
        };

        let config = {
          method  : "POST",
          data    : payload,
          url     : "/api/consol/updateStatus",
          name    : "[ Axios / updateStatus / 콘솔 및 오더 상태 수정 ]"
        }

        const ok = await this.$http(config)
          .then((res) => {
            this.$log.debug(`${config.name} 성공 => `, res.data)
            this.$q.notify({
              type: 'positive',
              message: '콘솔과 소속 오더 상태가 변경되었습니다',
              position: 'top',
              timeout: 3000,
            })
            this.refreshSelectedConsol()
            return true
          })
          .catch((err) => {
            this.$log.debug(err)
            this.$q.notify({
              type: 'negative',
              message: '콘솔 수정에 실패했습니다',
              position: 'top',
              timeout: 3000,
            })
            const found = this.consolList.find(c => c.id === id)
            if (found) found.status = prevStatus
            if (this.selectedConsol?.id === id) this.selectedConsol.status = prevStatus
            return false
        })
        return ok
      } catch (error) {
        alert(`에러 발생: ${error.response?.data?.message || error.message}`)
      }
    },


    /**
     * Title        : 콘솔해제하기
     * Status       : Actived
     * Description  : 선택된 화물의 Consol 해제하기
     */
     async deConsolize() {
      this.$log.debug("[ De consolize ]")

      if(this.selectedList.length === 0){
        this.$q.notify({
          type: 'positive',
          message: '선택된 ORDER가 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return false
      }
     
      let payload = {
        orderList : this.selectedList.map(item => item.orderId)
      }

      let config = {
        method  : "POST",
        url     : "/api/consol/deConsolize",
        data    : payload,
        name    : "[ Axios / deConsolize ]"
      }

      await this.$http(config)
        .then(() => {
          this.$log.debug("콘솔이 해제되었습니다.")
          
          this.$q.notify({
            type: 'positive',
            message: '콘솔이 해제되었습니다',
            position: 'top',
            timeout: 3000,
          })
          this.refreshSelectedConsol()
        })
        .catch((err) => {
          this.$log.debug(err)
          alert('deConsolize 실패!')
      })
    },


    /**
     * Title        : 콘솔 삭제하기
     * Status       : Actived
     * Description  : 선택된 콘솔을 삭제합니다.
     */
    async deleteConsol(row) {
      if (!row || !row.id) {
        this.$q.notify({
          type: 'negative',
          message: '삭제할 콘솔을 찾을 수 없습니다',
          position: 'top',
          timeout: 3000,
        })
        return;
      }

      if (!confirm("정말로 이 콘솔을 삭제하시겠습니까?")) {
        return;
      }

      let payload = {
        consoleId: row.id
      };

      let config = {
        method: "POST",
        url: "/api/consol/deleteConsol",
        data: payload,
        name: "[ Axios / 콘솔 삭제 ]"
      };

      await this.$http(config)
        .then(() => {
          this.$log.debug("콘솔이 삭제되었습니다.");
          this.$q.notify({
            type: 'positive',
            message: '콘솔이 삭제되었습니다',
            position: 'top',
            timeout: 3000,
          })

          this.$emit('load-consol-list'); // 콘솔 목록 새로고침 이벤트 발생
          this.selectedConsol = {}
          this.orderList = []

        })
        .catch((err) => {
          this.$log.debug(err);
          alert('콘솔 삭제 실패!');
        });
    },


    /**
     * Title        : Excel download
     * Status       : Actived
     * Description  : 
     * 선택된 콘솔에 consolize 된 Order 목록을 엑셀로 다운로드
     * ExcelJs 라이브러리 사용
     * 
     *                
     */
    async excelDownload (partnerId, partnerName) {
      const selectedConsolId = this.selectedConsol.id
      const selectedConsolMblNo = this.selectedConsol.mblNo
      if (!selectedConsolId) {
        this.$q.notify({ type: 'warning', message: '콘솔을 먼저 선택하세요', position: 'top', timeout: 2000 })
        return
      }

      let payload = {
        consoleId : selectedConsolId,
        partnerId : partnerId,
        partnerName : partnerName
      }

      const config = {
        method  : 'POST',
        url     : `/api/consol/downloadExcel`,
        data: payload,
        name    : '[ Axios / consolize 된 목록을 엑셀로 다운로드 ]',
        responseType: 'blob'
      }

      try {
        const res = await this.$http(config)
        this.$log.debug('/consol/downloadExcel 결과 = ', res)

        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `G1_upload_consol_${selectedConsolMblNo}_${partnerName}.xlsx`
        link.click()
        window.URL.revokeObjectURL(link.href)
      } catch (err) {
        this.$log.debug('/consol/excelDownload 실패', err)
        this.$q.notify({ type: 'negative', message: '엑셀 다운로드 실패', position: 'top', timeout: 10000 })
      }
    },


    /**
     * Title        : 토글 기능
     * Status       : Actived
     * Description  : 클릭한 콘솔의 expanded 상태를 반전시킴
     */
    toggle(evt,idx) {
      const id = this.consolList[idx]?.id
      if (!id) {
        return
      }
      this.$log.debug("콘솔 토글 클릭", idx, id, this.expandedMap[id]);
      this.expandedMap[id] = !this.expandedMap[id];
    }

  },
  mounted() {
    this.$log.debug("selectedConsol", this.selectedConsol)
  },
}
</script>

<template>
  <div id="consol-list-container">

    <!-- S : 콘솔 목록 -->
    <div class="side-consol-list">
      <div class="consol-list">
        <div v-if="!loading && consolList.length === 0" class="empty-list">
          조회된 콘솔이 없습니다.
        </div>
        <q-card 
          v-for="consol in consolList"
          :class="{ 'selected': selectedConsol.id === consol.id }"
          @click="() => {if(selectedConsol.id !== consol.id) { onLoadConslizedList($event, consol) }}"
          :key="consol.id">
          
          <q-card-section>
            <div class="no-wrap items-center">
              <div class="text-h6">
                MBL No.<br />
                {{ consol.mblNo }}
              </div>
              <q-badge :color="getStatusColor(consol.status)" class="q-mt-sm">
                {{ consol.statusLabel || consol.status }}
              </q-badge>
              <div class="text-subtitle1">
                운항편명 : {{ consol.freightCode }}
              </div>
              <div class="text-subtitle1">
                총 오더 {{ consol.totalOrderQty }} 개
              </div>
              <div class="text-subtitle2 text-grey-8">
                <q-select 
                  v-model="consol.status" 
                  :options="this.$store.getters.getConsolStatusList"
                  @focus="savePrevStatus(consol)"
                  @update:model-value="confirmUpdateConsolStatus(consol.id, $event, consol._prevStatus)"
                  label="콘솔상태" 
                  emit-value
                  map-options
                  behavior="menu"
                  @click.stop
                  :disable="selectedConsol.id !== consol.id" />
              </div>
            </div>

            <!--
            <q-btn
              clickable 
              v-close-popup
              flat
              class="full-width"
              :icon="consol.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
              @click.stop.prevent="toggle(event, idx)" >
            </q-btn>
            -->
          </q-card-section>
        </q-card>
      </div>
    </div>
    <!--// E : 콘솔 목록 -->

    <!-- S : 콘솔에 실린 오더 목록 -->
    <div class="selected-consol-order-list">
      <q-inner-loading v-if="detailLoading" :showing="true">
        <q-spinner color="primary" size="42px" />
      </q-inner-loading>

      <q-card
        flat
        class="q-py-lg">
        <q-card-section 
          class="q-py-none"
          v-show="Object.keys(selectedConsol).length > 0">
          <!-- ID : {{ consol.id }}<br /> -->
          <div class="row q-col-gutter-sm items-center">
            <div class="col">
              <div class="text-h6">
                {{ selectedConsol.departCity }} -> {{ selectedConsol.arrivalCity }}
              </div>
            </div>
            <div class="col-6 text-right">
              <q-btn-dropdown 
                icon="backup_table"
                color="secondary" 
                label="엑셀 다운로드">
                <q-list>
                  <template
                    v-for="partner in partnerList"
                    :key="partner.id ?? partner.name">
                    <q-item clickable v-close-popup @click="excelDownload(partner.id, partner.name)">
                      <q-item-section>
                        <q-item-label>{{ partner.name }}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </template>
                </q-list>
              </q-btn-dropdown>
              <q-btn
                icon="more_vert"
                clickable
                flat />

                <!-- 메뉴 -->
                <q-menu
                  anchor="bottom right"
                  self="top right"
                  transition-show="jump-down"
                  transition-hide="jump-up"
                >
                  <q-list style="min-width: 150px">
                    <q-item 
                      clickable 
                      v-close-popup 
                      @click="modalConsol = true">
                      <q-item-section>콘솔 정보 수정</q-item-section>
                    </q-item>

                    <q-item 
                      clickable 
                      v-close-popup 
                      @click="deleteConsol(selectedConsol)">
                      <q-item-section>콘솔 삭제</q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
            </div>
          </div>
          <div class="text-subtitle1">
            {{ selectedConsol.etd }} ~ {{ selectedConsol.eta }}
          </div>
          <div class="text-subtitle1">
            메모 : {{ selectedConsol.memo }}
          </div>
          <div class="text-subtitle2 q-mb-sm">
            최종수정일 : {{ selectedConsol.updated_at }}<br />
            등록일 : {{ selectedConsol.created_at }}
          </div>
        </q-card-section>
      </q-card>

      <q-separator />

      <q-banner v-if="Object.keys(selectedConsol).length === 0" class="empty-detail">
        <template #avatar>
          <q-icon name="inventory_2" color="grey-6" />
        </template>
        좌측 목록에서 콘솔을 선택하면 연결된 오더와 상세 정보를 확인할 수 있습니다.
      </q-banner>

      <q-table
        v-else
        class="my-sticky-virtscroll-table"
        virtual-scroll
        v-model:selected="selectedList"
        selection="multiple"
        :rows-per-page-options="[500]"
        :virtual-scroll-sticky-size-start="48"
        :rows="orderList || []"
        :columns="orderColumns"
        :pagination="initialPagination"
        row-key="orderId">
    
        <template v-slot:top-left>
          <h6 class="q-my-sm">
            H.수량 : {{ selectedConsol.totalQty }} | 
            H.중량 : {{ selectedConsol.totalWeight }} | 
            부피중량 : {{ selectedConsol.totalVolumeWeight || 0 }}
          </h6>
        </template>
        

        <template v-slot:top-right>
          <q-btn
            color="primary"
            size="md"
            label="선택 오더 연결 해제"
            class="q-ml-sm"
            @click="deConsolize"/>
        </template>
      </q-table>   
    </div>
    <!--// E : 콘솔에 실린 오더 목록 -->
  </div>

  <teleport to="body">
		<q-dialog 
      v-model="modalConsol"
      transition-show="slide-up"
      transition-hide="slide-down">

      <RegiConsolForm 
        :mode="'modify'"
        :title="'콘솔 수정'"
        :consolInfo="selectedConsol"
        @refresh-list="refreshSelectedConsol"
        @close-modal="modalConsol = false"  />

    </q-dialog>

  </teleport>

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#consol-list-container {
  display: flex;
  flex: 1;
  flex-direction: row;

  height: 100%;
  min-height: 600px;

  background-color: rgb(230, 230, 230);

  .side-consol-list, .selected-consol-order-list {
    position: relative;
  }

  .empty-list,
  .empty-detail {
    padding: 24px 16px;
    color: #6f7d7d;
    line-height: 1.6;
  }


  .side-consol-list {
    max-width: 250px;
    overflow-y: auto;

    left: 1px;

    z-index: 101;

    .consol-list {
      min-width: 200px;
      overflow-y: auto;

      display: flex;
      flex-direction: column;

      .q-card {
        cursor: pointer;
        box-shadow: none;
        border-radius: 0;
        /* 
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; */
        margin-bottom: 0;

        border-right: 1px solid rgb(200, 200, 200);
        border-bottom: 1px solid rgb(150, 150, 150);

        background-color: rgb(230, 230, 230);

        position: relative;
        z-index: 103;

        padding: 20px 16px;

        &:last-child {
          border-bottom: 0;
        }

        &.selected {
          border: 1px solid rgb(200, 200, 200);
          border-right: 1px solid white;
          
          background-color: white;
          box-shadow: 5px 5px 5px rgb(200, 200, 200);

          margin-bottom: 8px;

          z-index: 104;
        }
      }

      .delete {
        flex: auto;
      }
    }
  }

  /**
  콘솔된 오더목록
  */
  .selected-consol-order-list {
    flex: 1;
    overflow-y: auto;

    z-index: 100;

    border: 1px solid rgb(200, 200, 200);
    box-shadow: 5px 5px 5px rgb(200, 200, 200);
    background-color: white;
    
    height: 100%;
    min-height: 600px;
    padding: 10px;

    .my-sticky-virtscroll-table {
      position: relative;
      height: 100%;
      width: 100%;
    } 
  }

  /**
    최대 768px 넓이까지
   */
  @media screen and (max-width: 768px) {
    flex-direction: column;

    .selected-consol-order-list {
      max-height: none;
      overflow-y: auto;
    }
    
    .side-consol-list {
      max-width: fit-content;
      width: 100%;
      left: 0;
      bottom: -1px;

      .consol-list {
        flex-direction: row;

        .q-card {
          width: 100%;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;

          &.selected {
            border: 1px solid rgb(200, 200, 200);
            border-bottom: 1px solid white;
            
            background-color: white;
            box-shadow: 5px 5px 5px rgb(200, 200, 200);

            margin-right: 8px;
            margin-bottom: 0;

            z-index: 104;

            &::after {
              content: '';
              position: absolute;
              left: 0;

              width: 100%;
              border-bottom: 1px solid white;
            }
          }
        }
      }
    }
  }
}

</style>
